import { Component, inject, input, output } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import {
  DmIcon,
  DmSidebar,
  DmSidebarCollapsible,
  DmSidebarContent,
  DmSidebarFooter,
  DmSidebarGroup,
  DmSidebarHeader,
  DmSidebarInput,
  DmSidebarMenu,
  DmSidebarMenuButton,
  DmSidebarMenuItem,
  DmSidebarMenuSubButton,
  DmSidebarMenuSubItem,
  DmSidebarTrigger,
  DmTooltip,
} from '@digitale-menschen/component-library-angular';
import {
  AccountMenuComponent,
  LexplusLogoComponent,
  LOCALIZED_SHARED_ROUTES,
  LocalizedRouteService,
  SHARED_ROUTE_IDS,
} from '@lexplus-shared-lib';
import { AUTH_ROUTE_IDS, LOCALIZED_AUTH_ROUTES } from '@lexplus-authentication';

@Component({
  selector: 'lp-sidebar-navigation',
  imports: [
    LexplusLogoComponent,
    AccountMenuComponent,
    RouterLink,
    RouterLinkActive,
    DmSidebar,
    DmSidebarHeader,
    DmSidebarContent,
    DmSidebarFooter,
    DmSidebarGroup,
    DmSidebarInput,
    DmIcon,
    DmSidebarMenu,
    DmSidebarMenuItem,
    DmSidebarMenuButton,
    DmSidebarCollapsible,
    DmSidebarMenuSubItem,
    DmSidebarMenuSubButton,
    DmSidebarTrigger,
    DmTooltip,
  ],
  templateUrl: './sidebar-navigation.component.html',
  styleUrl: './sidebar-navigation.component.scss',
})
export class SidebarNavigationComponent {
  private readonly localizedRouteService = inject(LocalizedRouteService);
  private readonly router = inject(Router);

  /** Mirrors the provider's collapsed state, forwarded to the account menu. */
  public readonly collapsed = input<boolean>(false);

  /** Emitted for interactions that should close the mobile drawer but don't
   * navigate (route changes close it on their own via the app's Router
   * subscription) — currently just the search trigger. */
  public readonly closeMobileSidebar = output<void>();

  protected path(routeId: keyof typeof SHARED_ROUTE_IDS): string {
    return `/${this.localizedRouteService.getLocalizedRoute(LOCALIZED_SHARED_ROUTES[SHARED_ROUTE_IDS[routeId]])}`;
  }

  /** Placeholder for the future command palette; the search field is only a
   * trigger for now, no live filtering is wired up yet. */
  protected openCommandPalette(): void {
    this.closeMobileSidebar.emit();
  }

  protected logout(): void {
    const logoutPath = this.localizedRouteService.getLocalizedRoute(
      LOCALIZED_AUTH_ROUTES[AUTH_ROUTE_IDS.ROOT],
      LOCALIZED_AUTH_ROUTES[AUTH_ROUTE_IDS.LOGOUT],
    );
    void this.router.navigateByUrl(`/${logoutPath}`);
  }
}
